export default "__VITE_ASSET__B$bKtWrs__"